import React from 'react';
import CheckCircleIcon from '../icons/checkcircle';
import CrossCircleIcon from '../icons/crosscircle';

interface ComplianceMarkerProps {
  compliance: string;
}
export function ComplianceMarker({ compliance }: ComplianceMarkerProps) {
  switch (compliance) {
    case 'OK':
      return (
        <>
          <CheckCircleIcon fill="green" className="icon" /> Ok
        </>
      );
    case 'FAIL':
      return (
        <>
          <CrossCircleIcon fill="red" className="icon" /> Fail
        </>
      );
    case 'NOT_IN_SERVICE':
      return <span>Not in service</span>;
    case 'UNKNOWN':
      return <span>Unknown</span>;
    default:
      return <span>{compliance}</span>;
  }
}
